import gql from 'graphql-tag';
import FieldsMessage from "graphql/fields/FieldsMessage";
import HelperGraphql from 'utils/helper-graphql'
import VariablesPagination from 'graphql/variables/VariablesPagination'

const fields = {
	...VariablesPagination,
	'kind': '[String]',
	'active': '[String]',
};

export default gql(`
	query messages( ${ HelperGraphql.createFields( fields ) } ) {
		messages( ${ HelperGraphql.createVariables( fields ) } ) {
			${FieldsMessage}
	        
	        attachment {
	            name
	            guid
	        }
		}
	}
`);

